import { FeatureProperty } from 'cadenza/map/feature-property';

export const SketchFeatureProperty =  Object.assign({
  PALETTE_ITEM_REFERENCE: 'paletteItemReference',
  OLD_STYLE_ITEM: 'oldStyleItem',
  GROUP: 'group',
  GROUP_EXTENT: 'groupExtent',
  GROUP_FEATURES: 'groupFeatures',
  STYLE_ITEM: 'styleItem'
}, FeatureProperty);
